import NoLegacySupport from "~/features/legacy/NoLegacySupport";

export default function LegacyDatasetPage() {
  return <NoLegacySupport />;
}
